import { Component } from "@angular/core";
import { StudentDashboardComponent } from "../../student-dashboard/student-dashboard.component";
import { CommonModule } from "@angular/common";
import { Router, RouterOutlet } from "@angular/router";
import { HeaderComponent } from "../../common/header/header.component";
import { SidebarComponent } from "../../common/sidebar/sidebar.component";
import { FooterComponent } from "../../common/footer/footer.component";
import { ToggleService } from "../../common/sidebar/toggle.service";
import { CustomizerSettingsService } from "../../customizer-settings/customizer-settings.service";

@Component({
  selector: "app-student-dash-layout",
  standalone: true,
  imports: [
    StudentDashboardComponent,
    CommonModule,
    SidebarComponent,
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
  ],
  templateUrl: "./student-dash-layout.component.html",
  styleUrl: "./student-dash-layout.component.scss",
})
export class StudentDashLayoutComponent {
  isSidebarToggled: boolean = false;
  isToggled: boolean = false;

  constructor(
    public router: Router,
    private toggleService: ToggleService,
    public themeService: CustomizerSettingsService
  ) {
    this.toggleService.isSidebarToggled$.subscribe((isSidebarToggled) => {
      this.isSidebarToggled = isSidebarToggled;
    });
    this.themeService.isToggled$.subscribe((isToggled) => {
      this.isToggled = isToggled;
    });
  }
}
